import { useFormContext } from 'react-hook-form';
import { HelpTip } from '#components/atoms/forms/help-tip/HelpTip.tsx';
import { ErrorMessage, Input, Label } from '#components/atoms/forms/index.ts';
import { Field } from '#components/patterns/forms/field/Field.tsx';
import { setValueAsNumberOrNull } from '#util/validation/set-value-as-number-or-null.ts';
import type { HostFormData } from '../host-form-schema.ts';
import styles from './PublicAddressRow.module.css';

/** The `address:port` pair a lighthouse is dialed at. Two fields, but one line of address to the user. */
export function PublicAddressRow() {
  const {
    register,
    formState: { errors },
  } = useFormContext<HostFormData>();

  return (
    <div>
      <div className={styles.PublicAddressRow}>
        <Field id="public-ip-or-hostname" className="grow">
          <div className="flex align-center">
            <Label htmlFor="public-ip-or-hostname">Public IP or hostname</Label>
            <HelpTip className="pad-0 ml-4">
              <span id="ip-or-hostname-help">
                This should be a static IPv4 address or hostname and UDP port at which the lighthouse can be reached
                from the public internet.
              </span>
            </HelpTip>
          </div>

          <Input
            className="width-100"
            hasError={Boolean(errors.publicIPOrHostname)}
            autoComplete="off"
            aria-describedby="ip-or-hostname-help"
            {...register('publicIPOrHostname')}
          />
        </Field>
        <div className={styles.PublicAddressRow_portSeparator}>:</div>
        <Field label="Port">
          <Input
            className={styles.PublicAddressRow_portInput}
            type="number"
            // One beyond the real 0–65535 range: the form has no noValidate, so honest
            // bounds let native validation block the submit before zod styles the error.
            min={0}
            max={65536}
            hasError={Boolean(errors.listenPort)}
            inputMode="numeric"
            {...register('listenPort', {
              setValueAs: setValueAsNumberOrNull,
            })}
          />
        </Field>
      </div>
      {errors.publicIPOrHostname ?
        <ErrorMessage>{errors.publicIPOrHostname.message}</ErrorMessage>
      : errors.listenPort ?
        <ErrorMessage>{errors.listenPort.message}</ErrorMessage>
      : null}
    </div>
  );
}
